// @flow
import * as React from 'react';

import { Label, Input, FormGroup, Tooltip } from '../../Form';
import ErrorField from '../ErrorField';
import Lock from '../../../components/Icons/Lock';
import { BorderedIcon } from "../../../components";

type Props = {
	label: string,
	name: string,
	input: Object,
	type: string,
	placeholder: string,
	tooltip: {
		title: string,
		description: string,
	},
	meta: {
		touched: any,
		error: string,
		warning: string,
	},
	is_disabled: boolean,
};

const is_error = meta => {
	return !!(meta.touched && meta.error);
};

export const FormField = ({
	label,
	name,
	type,
	placeholder,
	input,
	tooltip,
	is_disabled,
	meta: { touched, error, warning }
}: Props ) => (
	<div>
		<Label htmlFor={name} is_error={is_error({ touched, error })}>
			{label}
		</Label>
		{ touched && ((
			error && <ErrorField>{error}</ErrorField>) ||
			(warning && <ErrorField>{warning}</ErrorField>
			))
		}
		<FormGroup>
			{is_disabled ? (
				<BorderedIcon padding='.25em'>
					<Lock size="2" />
				</BorderedIcon>
			) : ''}
			<Input
				input={input}
				name={name}
				type={type}
				placeholder={placeholder}
				is_disabled={is_disabled}
				is_error={is_error({ touched, error })}
			/>
			<Tooltip {...tooltip} />
		</FormGroup>
	</div>
);

export default FormField;


// WEBPACK FOOTER //
// ./src/components/Form/FormField/index.js